import { ApiError } from "@/api/client";

/** What to show for a failed request: the server's own sentence where it gave one. */
export function errorText(
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (error instanceof ApiError) {
    // A form's own field message says what to fix; a rule the server refused
    // explains itself in `detail`.
    const [field, messages] = Object.entries(error.fieldErrors)[0] ?? [];
    if (field && messages?.[0])
      return `${field.replace(/_/g, " ")}: ${messages[0]}`;
    return error.detail || fallback;
  }
  if (error instanceof Error && error.name === "NetworkError") {
    return "Could not reach Stokkie Stokvel. Check your connection and try again.";
  }
  return fallback;
}
